<template>
  <!-- <nav>
    <router-link to="/">Cliente</router-link> |
    <router-link to="/pastelero">Pastelero</router-link>
  </nav> -->
  <router-view/>

</template>

<style>
  * {
    margin: 0;
    padding: 0;
  }


</style>
